import { render, staticRenderFns } from "./admin-mrr.vue?vue&type=template&id=4d7ed0ae&scoped=true&"
import script from "./admin-mrr.vue?vue&type=script&lang=js&"
export * from "./admin-mrr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7ed0ae",
  null
  
)

export default component.exports